import { ReactNode, useCallback } from 'react';

import { useIcon } from '~extension/icon-library/context/Icons';
import { useSearch } from '~extension/icon-library/context/Search';
import { Tag } from '../Tag';
import { Box } from './Box';

type InfoProps = { icon?: Icon };
export const Info = ({ icon }: InfoProps) => {
  const { setQuery } = useSearch();
  const { closeIcon } = useIcon();
  const handleTagClick = useCallback(
    (tag: string) => {
      setQuery(tag);
      closeIcon();
    },
    [setQuery, closeIcon],
  );

  if (icon) {
    return (
      <Box title="Info">
        <div className={`text-xs`}>
          <InfoItem title="Title">{icon.title}</InfoItem>
          <InfoItem title="Format">SVG</InfoItem>
          <InfoItem title="Tags">
            {icon.tags.map((tag, idx) => (
              <div className={`mr-1 my-px`} key={`${tag}_${idx}`}>
                <Tag label={tag} onClick={handleTagClick} />
              </div>
            ))}
          </InfoItem>
        </div>
      </Box>
    );
  }
  return null;
};

const InfoItem = ({ title, children }: { title: string; children: ReactNode }) => {
  return (
    <div className={`flex items-center border-gray border-solid border-0 border-t py-2`}>
      <div className={`box-border flex items-center opacity-50 py-0 px-2 text-left`}>{title}</div>
      <div className={`flex flex-wrap px-0 py-px`}>{children}</div>
    </div>
  );
};
